import { useCallback, useEffect, useMemo, useState } from "react";

export const useInfiniteScroll = <T>(items: T[], batchSize: number = 20) => {
    const [visibleCount, setVisibleCount] = useState(batchSize);

    useEffect(() => {
        setVisibleCount(Math.min(batchSize, items.length));
    }, [items.length, batchSize]);

    const visibleItems = useMemo(
        () => items.slice(0, visibleCount),
        [items, visibleCount],
    );

    const loadMore = useCallback(() => {
        setVisibleCount((prev) => Math.min(prev + batchSize, items.length));
    }, [batchSize, items.length]);

    const hasMore = visibleCount < items.length;

    const reset = useCallback(() => {
        setVisibleCount(batchSize);
    }, [batchSize]);

    return { visibleItems, loadMore, hasMore, reset };
};
